import { render, staticRenderFns } from "./AddEdit.vue?vue&type=template&id=abda8958&scoped=true&"
import script from "./AddEdit.vue?vue&type=script&lang=js&"
export * from "./AddEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddEdit.vue?vue&type=style&index=0&id=abda8958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abda8958",
  null
  
)

export default component.exports